module.exports = __webpack_public_path__ + "static/media/medium-md-1.3f62cd16.jpg";